// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2CPS5","addWidgetButton":"Header_addWidgetButton__2JhkM","dashboardTabs":"Header_dashboardTabs__31bnV","active":"Header_active__2VoxA"};